
const getQuestionVariant = (
    tests:   number[][], 
    level:   number, 
    testNum: number
) => {

    let qvar = 'dnd';

    if ( level === 0 || ( level === 2 && !!(testNum%2))) {
        qvar = 'input'
    }

    const q_ = !!tests.length ? tests[level][testNum] : 0

    return {
        q_:   q_,
        qvar: qvar
    }

}

export default getQuestionVariant